export default __webpack_public_path__ + "static/media/thumbnail_02.27d18054.png";